// Briefpapier: bankgegevens, (seizoens)openingsuren en betaal-QR voor klantdocumenten.
export const DAY_NAMES = {
  nl: ["Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"],
  fr: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
  de: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
  no: ["Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag", "Søndag"],
  da: ["Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag", "Søndag"],
  es: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
  en: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
};

export const STAT_LABELS = {
  nl: { bank: "Bankgegevens", hours: "Openingsuren", closed: "Gesloten", scan: "Scan om te betalen" },
  fr: { bank: "Coordonnées bancaires", hours: "Heures d'ouverture", closed: "Fermé", scan: "Scannez pour payer" },
  de: { bank: "Bankverbindung", hours: "Öffnungszeiten", closed: "Geschlossen", scan: "Zum Bezahlen scannen" },
  no: { bank: "Bankopplysninger", hours: "Åpningstider", closed: "Stengt", scan: "Skann for å betale" },
  da: { bank: "Bankoplysninger", hours: "Åbningstider", closed: "Lukket", scan: "Scan for at betale" },
  es: { bank: "Datos bancarios", hours: "Horario de apertura", closed: "Cerrado", scan: "Escanee para pagar" },
  en: { bank: "Bank details", hours: "Opening hours", closed: "Closed", scan: "Scan to pay" },
};

export const statLabel = (lang, key) => (STAT_LABELS[lang] || STAT_LABELS.en)[key] || key;
export const dayName = (lang, i) => (DAY_NAMES[lang] || DAY_NAMES.en)[i % 7];

export function bankLines(camp = {}) {
  return [
    camp.bank_name || null,
    camp.bank_account ? `IBAN ${camp.bank_account}` : null,
    camp.bank_bic ? `BIC ${camp.bank_bic}` : null,
  ].filter(Boolean);
}

const inSeason = (s, md) => {
  const start = s?.start || "";
  const end = s?.end || "";
  if (!start || !end) return false;
  return start <= end ? md >= start && md <= end : md >= start || md <= end;
};

export function activeSeason(camp = {}, on = new Date()) {
  const md = `${String(on.getMonth() + 1).padStart(2, "0")}-${String(on.getDate()).padStart(2, "0")}`;
  return (camp.hour_seasons || []).find((s) => inSeason(s, md) && (s.hours || []).length) || null;
}

export function hoursTitle(camp = {}, lang = "nl", on = new Date()) {
  const s = activeSeason(camp, on);
  return s?.name ? `${statLabel(lang, "hours")} (${s.name})` : statLabel(lang, "hours");
}

export function hoursLines(camp = {}, lang = "nl", on = new Date()) {
  const rows = activeSeason(camp, on)?.hours || camp.opening_hours || [];
  return rows.slice(0, 7).map((row, i) => {
    const r = row || {};
    if (r.closed) return `${dayName(lang, i)}: ${statLabel(lang, "closed")}`;
    if (r.from && r.to) return `${dayName(lang, i)}: ${r.from} – ${r.to}`;
    return null;
  }).filter(Boolean);
}

// EPC069-12 betaal-QR (SEPA-overschrijving), leesbaar door bankapps in de SEPA-zone.
export function epcPayload(camp = {}, amount = 0, reference = "") {
  const iban = (camp.bank_account || "").replace(/\s/g, "");
  const name = (camp.camp_name || "").slice(0, 70);
  const amt = Math.round((Number(amount) || 0) * 100) / 100;
  if (iban.length < 15 || !name || amt <= 0) return null;
  return ["BCD", "002", "1", "SCT", (camp.bank_bic || "").replace(/\s/g, ""), name, iban,
    `EUR${amt.toFixed(2)}`, "", "", String(reference || "").slice(0, 140)].join("\n");
}

export const EMPTY_HOURS = Array.from({ length: 7 }, () => ({ from: "", to: "", closed: false }));

// "06-15" ↔ "15/06"
export const keyToDdmm = (k) => (/^\d{2}-\d{2}$/.test(k || "") ? `${k.slice(3)}/${k.slice(0, 2)}` : "");
export const ddmmToKey = (v) => {
  const m = /^(\d{1,2})\s*[/-]\s*(\d{1,2})$/.exec((v || "").trim());
  if (!m) return "";
  return `${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}`;
};
